import { render } from "./Footer.vue?vue&type=template&id=aa981ab2&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=aa981ab2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aa981ab2"

export default script